import React, { useState, useEffect, useCallback } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'

import LoadingComponent from '../../../../components/loading/Index'

const Edit = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [error, setError] = useState(null)
    const [isLoading, setLoading] = useState(true)
    const [update, setUpdate] = useState(false)
    const [item, setItem] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.PagePremium.Show(id, header)
        if (data) {
            setItem(data)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])

    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])

    // Handle image
    const handleImage = async (event) => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 700) {
                setError({ ...error, image: 'Select less than 700KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })

            let formData = new FormData()
            formData.append('vip_review_image', file)
            setItem({ ...item, image: null })

            const response = await Requests.PagePremium.UpdateImage(id, formData, header)
            if (response.status === true) {
                toast.success(response.message)
            }
        }
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            setUpdate(true)

            await Requests.PagePremium.Update(id, data, header)
            setUpdate(false)
            navigate('/dashboard/website/premium')
        } catch (error) {
            if (error) console.log(error)
        }
    }

    if (isLoading) return <LoadingComponent />

    return (
        <div className="premium-story pb-4">

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Edit Story</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/story"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    {/* how_it_works 1 */}
                                    <div className="form-group mb-4">
                                        {errors.how_it_works && errors.how_it_works.message ? (
                                            <p className="text-danger">{errors.how_it_works && errors.how_it_works.message}</p>
                                        ) : <p>HOW IT WORKS</p>}

                                        <textarea
                                            type="text"
                                            name="how_it_works"
                                            defaultValue={item.how_it_works}
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short introduction"
                                            {...register("how_it_works",{
                                                required: "how_it_works is required"
                                            })}
                                        />
                                    </div>

                                    {/* VIP Consultants  */}
                                    <div className="form-group mb-4">
                                        {errors.vip_consultants && errors.vip_consultants.message ? (
                                            <p className="text-danger">{errors.vip_consultants && errors.vip_consultants.message}</p>
                                        ) : <p>VIP Consultants</p>}

                                        <textarea
                                            type="text"
                                            name="vip_consultants"
                                            defaultValue={item.vip_consultants}
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short vip_consultants"
                                            {...register("vip_consultants",{
                                                required: "vip_consultants is required"
                                            })}
                                        />
                                    </div>

                                    {/* VIP Matches  */}
                                    <div className="form-group mb-4">
                                        {errors.vip_matches && errors.vip_matches.message ? (
                                            <p className="text-danger">{errors.vip_matches && errors.vip_matches.message}</p>
                                        ) : <p>VIP Matches</p>}

                                        <textarea
                                            type="text"
                                            name="vip_matches"
                                            defaultValue={item.vip_matches}
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short vip_matches"
                                            {...register("vip_matches",{
                                                required: "vip_matches is required"
                                            })}
                                        />
                                    </div>

                                    {/* VIP Privacy */}
                                    <div className="form-group mb-4">
                                        {errors.vip_privacy && errors.vip_privacy.message ? (
                                            <p className="text-danger">{errors.vip_privacy && errors.vip_privacy.message}</p>
                                        ) : <p>VIP Privacy </p>}

                                        <textarea
                                            type="text"
                                            name="vip_privacy"
                                            defaultValue={item.vip_privacy}
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short vip_privacy"
                                            {...register("vip_privacy",{
                                                required: "vip_privacy is required"
                                            })}
                                        />
                                    </div>

                                    < br /> < br />
                                    {/* vip_review */}
                                    <div className="row">

                                        {/* vip_review_title */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.vip_review_title && errors.vip_review_title.message ? (
                                                    <p className="text-danger">{errors.vip_review_title && errors.vip_review_title.message}</p>
                                                ) : <p>VIP Review Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="vip_review_title"
                                                    defaultValue={item.vip_review_title}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter vip_review_title"
                                                    {...register("vip_review_title",{ required: "vip_review_title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* vip_review_sub_title */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.vip_review_sub_title && errors.vip_review_sub_title.message ? (
                                                    <p className="text-danger">{errors.vip_review_sub_title && errors.vip_review_sub_title.message}</p>
                                                ) : <p>VIP Review Sub Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="vip_review_sub_title"
                                                    defaultValue={item.vip_review_sub_title}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter vip_review_sub_title"
                                                    {...register("vip_review_sub_title",{ required: "vip_review_sub_title is required" })}
                                                />
                                            </div>
                                        </div>


                                    </div>


                                    <div className="form-group mb-4">
                                        {errors.vip_review && errors.vip_review.message ? (
                                            <p className="text-danger">{errors.vip_review && errors.vip_review.message}</p>
                                        ) : <p>VIP Review</p>}

                                        <textarea
                                            type="text"
                                            name="vip_review"
                                            defaultValue={item.vip_review}
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short vip_review"
                                            {...register("vip_review",{
                                                required: "vip_review is required"
                                            })}
                                        />
                                    </div>


                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.vip_review_image ? <p className="text-danger">{error.vip_review_image}</p> : <p>vip_review_image</p>}
                                        <div className="d-flex">
                                            {
                                                selectedFile ?
                                                    <div className="img-container text-center mr-2">
                                                        <div className="image border">
                                                            <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                        </div>
                                                    </div>
                                                    :
                                                    item && item.vip_review_image ?
                                                        <div className="img-container text-center mr-2">
                                                            <div className="image border">
                                                                <img src={item.vip_review_image} className="img-fluid" alt="..." />
                                                            </div>
                                                        </div>
                                                        : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {update ? 'Updating...' : 'Update'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Edit;
